{
  "title": "彈珠 / Plinko",
  "subtitle": "落球路徑由後端決定，前端只播放結果",
  "connecting": "連線中…",
  "connected": "已連線",
  "reconnecting": "重連中…",
  "unauthorized": "未授權",
  "authFailed": "登入失敗",
  "retryLogin": "重試連線",
  "backLobby": "回大廳",
  "lobby": "大廳",
  "balance": "餘額 {{amount}}",
  "bet": "下注金額",
  "half": "1/2",
  "max": "全下",
  "quickChips": "快速籌碼",
  "close": "關閉",
  "risk": "風險等級",
  "riskLow": "低風險",
  "riskMedium": "中風險",
  "riskHigh": "高風險",
  "waiting": "等待投放",
  "dropping": "彈珠投放中…",
  "oddsLoading": "正在載入賠率…",
  "oddsLoadFailed": "目前無法載入此風險等級的賠率",
  "retryOdds": "重新載入賠率",
  "balanceRefreshFailed": "本局已完成，餘額暫時無法更新",
  "balanceOutcomeUnknown": "這筆下注結果尚未確認；請先重新整理餘額，再投放下一顆彈珠",
  "retryBalance": "重新整理餘額",
  "refreshingBalance": "正在更新餘額…",
  "drop": "投放彈珠",
  "slot": "槽位 {{n}}",
  "resultWin": "獲利",
  "resultLose": "未回本",
  "payout": "派彩 {{amount}}",
  "betFailed": "下注失敗",
  "rules": "遊戲規則",
  "rulesTitle": "彈珠 (Plinko) 遊戲規則",
  "rulesBody": "選擇下注金額與風險等級（低 / 中 / 高）。點擊投放後，彈珠將在釘板中彈跳落下。底部不同槽位對應不同的派彩倍率，兩側邊緣槽位倍率最高，中央槽位倍率較穩定。",
  "errors": {
    "insufficient_funds": "餘額不足",
    "user_not_found": "找不到使用者",
    "invalid_bet": "下注金額無效",
    "invalid_risk": "風險等級無效",
    "unauthorized": "請先登入",
    "play_failed": "遊戲失敗",
    "unknown": "發生錯誤"
  }
}
